function i(n, r) {
  if (n == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var e in r)
    Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
  return n;
}
export {
  i as default
};
